// extracted by mini-css-extract-plugin
export default {"progress":"progress_progress__xqZTM"};